import React, {Component} from "react";
import {
    BILATERAL_CONTROL_PANEL_ROUTE
} from "../../../../utils/constants/RoutesConstants";
import BilateralMarginCall from "./BilateralMarginCallView";
import {Growl} from "primereact/growl";
import {BilateralLoanService} from "../../../../service/bilateral/loan/BilateralLoanService";
import PropTypes from "prop-types";
import {amountCalculate} from "../../../../utils/formatters/Numbers";
import {MarginCallLoanService} from "../../../../service/bilateral/loan/MarginCallLoanService";

export default class BilateralMarginCallContainer extends Component {
    constructor(props) {
        super(props);

        this.bilateralLoanService = new BilateralLoanService();
        this.marginCallLoanService = new MarginCallLoanService();
        this.getDetailLoan = this.getDetailLoan.bind(this);
        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveMarginCall = this.saveMarginCall.bind(this);
        this.bilateralLoanData = React.createRef();
        this.bilateralAssignedCollateral = React.createRef();
        this.bilateralCollateralInAccount = React.createRef();

        this.state = {
            isLoading: true,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            loanId: this.props.location.state.selectedLoanControlPanel.id,
            collateralDetail: {}
        };
    };


    componentDidMount() {
        let loanId = this.props.location.state.selectedLoanControlPanel.id;
        this.getDetailLoan(loanId);
    }

    getDetailLoan(loanId){
        this.bilateralLoanService.getLoanDetail(loanId, true)
            .then( res => {
                if (this.validResponse(res)){
                    this.setState({
                        selectedLoan: res.data,
                        collateralDetail: res.data.collateralDetail
                    });
                    this.setLoanDetail(res.data);
                    this.setCollateralDetail(res.data.collateralDetail ?? {});

                }
            });
    }

    validResponse (res){
        if (res.status!== 200){
            this.growl.show({severity: 'error', summary: 'Error.',
                detail: res.message  + ' ' + res.debugMessage});
            return false;
        }
        return true;
    }

    setLoanDetail(loanData) {
        this.bilateralLoanData.current.state.selectedLoan = loanData ;
        this.bilateralLoanData.current.getLoan();
    }
    setCollateralDetail(collateralData) {
        this.bilateralAssignedCollateral.current.state.collateralDetail = collateralData;
        this.bilateralAssignedCollateral.current.setCollateralDetail();
    }


    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: BILATERAL_CONTROL_PANEL_ROUTE,
            message:message,
        });
    }

    saveMarginCall() {
        if (this.validGuaranteedAmount()) {
            this.loading(true);
            let params = {
                loanId: this.state.selectedLoan.id,
                collateralMovementList:
                    this.getCollateralListFromMap(this.bilateralCollateralInAccount.current.state.collateralToAssignMap)
            };
            this.marginCallLoanService.assignCollateralsMarginCall(params).then(
                res => {
                    if (this.validResponse(res)) {
                        this.loading(true);
                        this.handleReturnButton({
                            severity: 'success',
                            sumary: 'Éxito',
                            detail: 'Las garantías han sido guardadas exitosamente',
                        });
                    }
                });
        }
    }

    validGuaranteedAmount() {
        if (this.state.selectedLoan.amount >
            amountCalculate(this.bilateralCollateralInAccount.current.state.guaranteedAmountTotal)) {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Favor de validar las garantías"});
            return false;
        }
        return true;
    }

    getCollateralListFromMap(collateralMap) {
        let collateralList =[];
        for (const [key, value] of collateralMap) {
            collateralList.push({
                instrumentId: key,
                title: value
            });
        }
        return collateralList;
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <BilateralMarginCall
            isLoading={this.state.isLoading}
            bilateralLoanData={this.bilateralLoanData}
            messagesGrowl={messagesGrowl}
            loading={this.loading}
            handleReturnButton={this.handleReturnButton}
            saveMarginCall={this.saveMarginCall}
            selectedLoan={this.state.selectedLoan}
            bilateralAssignedCollateral={this.bilateralAssignedCollateral}
            collateralDetail={this.state.collateralDetail}
            bilateralCollateralInAccount={this.bilateralCollateralInAccount}
        />

    }
};

BilateralMarginCallContainer.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};